import React from 'react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum seawardIFrameLoadingStatus {
    LOADING,
    SUCCESS,
    FAILED,
}

export interface IFrameState {
    seawardIFrame: React.RefObject<any>
    isSeawardFrameLoading: seawardIFrameLoadingStatus
    seawardProvisionError: string
    isSeawardModalOpen: boolean
}

const initialState: IFrameState = {
    seawardIFrame: null,
    isSeawardFrameLoading: seawardIFrameLoadingStatus.LOADING,
    seawardProvisionError: undefined,
    isSeawardModalOpen: false,
}

export const iframeSlice = createSlice({
    name: 'iframeSlice',
    initialState,
    reducers: {
        setSeawardIFrame: (state, action: PayloadAction<React.RefObject<HTMLIFrameElement>>) => {
            state.seawardIFrame = action.payload
        },
        setIsSeawardFrameLoading: (state, action: PayloadAction<seawardIFrameLoadingStatus>) => {
            console.log('ATBase: setting frame loading status', action.payload)
            state.isSeawardFrameLoading = action.payload
        },
        setSeawardProvisionError: (state, action: PayloadAction<string>) => {
            console.log('ATBase: setting frame error status', action.payload)
            state.seawardProvisionError = action.payload
        },
        setIsSeawardModalOpen: (state, action: PayloadAction<boolean>) => {
            console.log('ATBase: setting seaward iframe modal open status', action.payload)
            state.isSeawardModalOpen = action.payload
        },
    },
})

export const {
    setSeawardIFrame,
    setIsSeawardFrameLoading,
    setSeawardProvisionError,
    setIsSeawardModalOpen,
} = iframeSlice.actions

export default iframeSlice.reducer
